import { reduce } from './reducer';
import { createGame } from './setup';
import type { Action, GameConfig, GameState, MapDef } from './types';

/** Rebuild a game from its seed and action log. Throws on the first illegal action. */
export function replay(map: MapDef, config: GameConfig, actions: readonly Action[]): GameState {
  let state = createGame(map, config);
  actions.forEach((action, i) => {
    const r = reduce(map, state, action);
    if (!r.ok) throw new Error(`Action ${i} (${action.type}) rejected: ${r.error}`);
    state = r.state;
  });
  return state;
}
